<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <CCol>
          <div class="table-responsive">
            <table id="dataTableLists"
              class="table table-sm table-hover table-striped table-bordered dt-responsive nowrap" style="width: 100%">
              <thead>
                <tr>
                  <th width="60">#Cita</th>
                  <th>Fecha</th>
                  <th>Servicio</th>
                  <!-- <th>Fecha</th> -->
                  <th>Descripción del Servicio</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in services" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ formatDate(service.date) }}</td>
                  <td>{{ service.service }}</td>
                  <td v-if="service.detail_service == null">{{ service.new_detail_service }}</td>
                  <td v-if="service.detail_service != null">{{ service.detail_service }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
    </template>
  </CModal>
</template>

<script>
import CModal from "../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";

export default {
  name: "c-servicesant-modal",
  components: {
    CModal,
  },
  data() {
    return {
      swal: null,
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    services: {
      type: Array,
      default: []
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("closeModalServiceAnt");
    },
    formatDate(date) {
      if (!date) return "";
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #00003a;
}

.color-white {
  color: white;
}

.tamanio {
  max-height: 180px;
  overflow-y: auto;
}
</style>